/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_UploadedInputs */

const cs_gallery_uploaded = /** @type {(inputs: Gallery_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky nahrány`)
};

const en_gallery_uploaded = /** @type {(inputs: Gallery_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos uploaded`)
};

/**
* | output |
* | --- |
* | "Photos uploaded" |
*
* @param {Gallery_UploadedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_uploaded = /** @type {((inputs?: Gallery_UploadedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_UploadedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_uploaded(inputs)
	return cs_gallery_uploaded(inputs)
});